import ReactDOM from "react-dom";
import { ReactChatbot } from "@vectara/react-chatbot";
import "./ui/_index.scss";
import "./index.scss";


const DEFAULT_CORPUS_KEY = "3";
const DEFAULT_CUSTOMER_ID = "2901857270";
const DEFAULT_API_KEY = "zwt_rPbT9mixSGC0vqJdQRZh7pZ7mEyFiqDHkuJh9g";
const DEFAULT_TITLE = "Vectara Docs Chatbot";
const DEFAULT_PLACEHOLDER = 'Try "What is Vectara?" or "How does RAG work?"';

const App = () => {
  return (
    <>
      <ReactChatbot
        corpusKeys={DEFAULT_CORPUS_KEY}
        customerId={DEFAULT_CUSTOMER_ID}
        apiKey={DEFAULT_API_KEY}
        title={DEFAULT_TITLE}
        placeholder={DEFAULT_PLACEHOLDER}
        exampleQuestions={["What is Vectara?", "How does RAG work?"]}
        inputSize="large"
        enableStreaming={true}
        numberOfSearchResults={10}
        customPrompt={undefined}
        language="eng"
        rerankerId={272725718}
        lambda={0.005}
        isInitiallyOpen={true}
        zIndex={9}
      />
    </>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
